import tools from './tools';

export function isSingle(element) {
    return element.type === 'select-one';
}

export function getValue(element) {
    return isSingle(element) ? element.value : Array.from(element.selectedOptions).map((option) => option.value);
}

export function setValue(element, value) {
    if (isSingle(element)) {
        element.value = value;
    } else {
        value = value.map((value) => String(value));

        Array.from(element.children).forEach((option) => (option.selected = value.includes(option.value)));
    }
}

// Select component
export default function () {
    let root,
        isSingle,
        pregenerated = false,
        loadingIntervalId = null;

    return {
        placeholder: '',

        get value() {
            return root._x_model ? root._x_model.get() : getValue(root);
        },

        set value(value) {
            root._x_model ? root._x_model.set(value) : setValue(root, value);
        },

        get disabled() {
            return root.disabled;
        },

        set disabled(value) {
            root.disabled = value;
        },

        init() {
            root = this.$root;
            isSingle = root.type === 'select-one';
            this.placeholder = root.querySelector('option[value=""]')?.innerHTML ?? '';
            pregenerated = root.children.length > (this.placeholder ? 1 : 0);

            const setEmptyClass = () => root.classList[root.value === '' ? 'add' : 'remove']('empty-select');
            root.addEventListener('change', setEmptyClass);

            this.$nextTick(() => {
                if (root._x_model) {
                    this.$watch(tools.getXModelValue(root), () => setEmptyClass());
                }

                setEmptyClass();
            });
        },

        generateOptions(values) {
            if (pregenerated) {
                pregenerated = false;
                return;
            }

            if (loadingIntervalId) {
                window.clearInterval(loadingIntervalId);
                loadingIntervalId = null;
            }

            const selectedValues = Array.from(root.selectedOptions).map((option) => option.value);

            root.length = 0;
            this.disabled = false;

            const createOption = (value, text) => {
                const option = document.createElement('option');
                option.value = value;
                option.innerText = text;

                return option;
            };

            if (this.placeholder) {
                root.appendChild(createOption('', this.placeholder));
            }

            for (const [key, value] of Object.entries(values)) {
                const option = createOption(key, value);

                if (selectedValues.includes(option.value)) {
                    option.selected = true;
                }

                root.appendChild(option);
            }

            if (isSingle && root.value === '') {
                root.classList.add('empty-select');
            }

            if (typeof this.postGenerateOptions === 'function') {
                this.postGenerateOptions();
            }
        },

        showLoadingProgress() {
            root.length = 1;
            this.disabled = true;

            const firstChild = root.children[0];
            const label = __('Loading');
            let counter = 3;

            firstChild.innerText = label + '.'.repeat(counter);
            loadingIntervalId = window.setInterval(() => (firstChild.innerText = label + '.'.repeat(counter > 10 ? (counter = 1) : counter++)), 100);
        },
    };
}
